// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2hKmT","alertIcon":"ConfirmModal_alertIcon__2siIZ"};